import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { D as DropdownButtonContent, a as DropdownIcon, b as DropdownButton$1 } from './Dropdown.styles-ObTzf42P.js';
import { u as useDropdownIsMobile } from './DropdownIsMobileContext-DIYFOYAu.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';
import { b as angleInlineEnd, g as angleDown } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-EM4gOTGb-B7bhIt-r.js';
import { w as withTaktFallbackId } from '../TaktIdContext/TaktIdContext-DlOuPWuU.js';

const StyledButton = withTaktFallbackId(DropdownButton$1);
const DropdownButton = ({
  buttonText,
  disabled,
  small,
  ...restProps
}) => {
  const isMobile = useDropdownIsMobile();
  return /*#__PURE__*/React__default.createElement(StyledButton, _extends({}, restProps, {
    taktFallbackId: createStormTaktId('trigger-button'),
    disabled: disabled,
    small: small
  }), /*#__PURE__*/React__default.createElement(DropdownButtonContent, null, buttonText), /*#__PURE__*/React__default.createElement(DropdownIcon, {
    type: isMobile ? angleInlineEnd : angleDown,
    $disabled: disabled,
    $small: small
  }));
};
DropdownButton.defaultProps = {
  disabled: false,
  small: false
};

export { DropdownButton as D };
//# sourceMappingURL=DropdownButton-Dr25gFHw.js.map
